import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthenticationInterceptor } from './authentication-interceptor.service';

/**
 * Having the HTTP Interceptors in a separate module is required for Lazy Loading feature modules which in turn import HttpClientModule or
 * import another module (such as UIKitLib) which imports HttpClientModule. If the interceptors are provided in the AppModule, any feature
 * module which imports HttpClientModule will instantiate a separate HttpClient and will not have the interceptors configured.
 *
 * To get the interceptors in your feature module, do one of the following:
 * (1) Make sure you do not import HttpClientModule into your feature module. Not even transitively through other modules!
 * (2) Import this module into the feature module. There is no need to import HttpClientModule explicitly in your feature module anymore.
 *
 */
@NgModule({ exports: [HttpClientModule], imports: [], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthenticationInterceptor,
            multi: true,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class HttpInterceptorsModule {
}
